import { createContext } from 'react';

export const ActualizadorContext = createContext();
